import {
    FETCH_BROKER_FIRM_OWNERS_FAILURE,
    FETCH_BROKER_FIRM_OWNERS_REQUEST,
    FETCH_BROKER_FIRM_OWNERS_SUCCESS
} from './types';

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchBrokerFirmOwners = (params) => ({
    type: FETCH_BROKER_FIRM_OWNERS_REQUEST,
    payload: params
});

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchBrokerFirmOwnersSuccess = (params) => ({
    type: FETCH_BROKER_FIRM_OWNERS_SUCCESS,
    payload: params
});

/**
 *
 * @param {string} error
 * @returns
 */
export const fetchBrokerFirmOwnersFailure = (error) => ({
    type: FETCH_BROKER_FIRM_OWNERS_FAILURE,
    error
});
